import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { makeStyles } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';

// eslint-disable-next-line no-unused-vars
const useStyles = makeStyles((theme) => ({
  input: {
    width: '100%',
    border: 0,
  },
}));

const NumberFormatWrapper = ({
  inputRef,
  onChange,
  format,
  pattern,
  readOnly,
  value,
  autoFocus,
  type,
  ...other
}) => {
  const classes = useStyles();

  const handleValueChange = (values) => {
    if (onChange) {
      if (values && values.formattedValue) {
        onChange({ target: { value: values.value } });
      } else {
        onChange({ target: { value: null } });
      }
    }
  };

  return (
    <NumberFormat
      required
      pattern={pattern}
      format={format}
      getInputRef={inputRef}
      onValueChange={handleValueChange}
      className={classes.input}
      readOnly={readOnly}
      value={value}
      autoFocus={autoFocus}
      type={type}
      {...other}
    />
  );
};

NumberFormatWrapper.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  format: PropTypes.string.isRequired,
  pattern: PropTypes.string.isRequired,
  readOnly: PropTypes.bool,
  value: PropTypes.string,
  autoFocus: PropTypes.bool,
  type: PropTypes.string.isRequired,
  other: PropTypes.any,
};

NumberFormatWrapper.defaultProps = {
  readOnly: false,
  value: null,
  autoFocus: false,
  onChange: undefined,
  other: undefined,
};

const NumberFormatInput = ({
  fullWidth,
  onChange,
  format,
  pattern,
  disabled,
  readOnly,
  value,
  inputAdornment,
  ref,
  onKeyPress,
  onKeyUp,
  autoFocus,
  type,
  ...other
}) => (
  <TextField
    fullWidth={fullWidth}
    variant="outlined"
    onChange={onChange}
    onKeyPress={onKeyPress}
    onKeyUp={onKeyUp}
    inputRef={ref}
    InputProps={{
      inputComponent: NumberFormatWrapper,
      inputProps: {
        format,
        pattern,
        readOnly,
        value,
        type,
        ...other,
      },
      startAdornment: inputAdornment,
    }}
    autoFocus={autoFocus}
    readOnly={readOnly}
    disabled={disabled}
  />
);

NumberFormatInput.propTypes = {
  fullWidth: PropTypes.bool,
  onChange: PropTypes.func,
  format: PropTypes.string.isRequired,
  pattern: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  inputAdornment: PropTypes.object,
  ref: PropTypes.object,
  readOnly: PropTypes.bool,
  onKeyPress: PropTypes.func,
  onKeyUp: PropTypes.func,
  autoFocus: PropTypes.bool,
  type: PropTypes.string,
  other: PropTypes.any,
};

NumberFormatInput.defaultProps = {
  fullWidth: true,
  disabled: false,
  value: null,
  inputAdornment: null,
  ref: null,
  readOnly: false,
  onKeyPress: null,
  onKeyUp: null,
  autoFocus: false,
  type: 'text',
  onChange: undefined,
  other: undefined,
};

export default NumberFormatInput;
